import { render, staticRenderFns } from "./RejectDispatch.vue?vue&type=template&id=319421c6&scoped=true"
import script from "./RejectDispatch.vue?vue&type=script&lang=js"
export * from "./RejectDispatch.vue?vue&type=script&lang=js"
import style0 from "./RejectDispatch.vue?vue&type=style&index=0&id=319421c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319421c6",
  null
  
)

export default component.exports